import React from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import Link from 'next/link';
import parseCategoryUrl from 'lib/parseCategoryUrl';
import { Category, Title, Text } from 'components/ArticleCard';
import Image from 'components/Image';

const CategoryStyled = styled(Category)`
    padding-top: 0;
    -webkit-line-clamp: 1;
`;

const TitleStyled = styled(Title)`
    -webkit-line-clamp: 1;
`;

const TextStyled = styled(Text)`
    -webkit-line-clamp: 3;
`;

const ArticleItem = ({ item }: { item: Article }) => (
    <Row>
        <Col span={8}>
            <Link href={`/artykuly/${item.seoSlug}`}>
                <Image
                    type="index"
                    height={153}
                    width={272}
                    alt={item.title}
                    src={item.openingImage}
                />
            </Link>
        </Col>
        <Col span={16} style={{ padding: '0 15px' }}>
            <CategoryStyled>
                <Link href={parseCategoryUrl(item.category)}>{item.category.title}</Link>
            </CategoryStyled>
            <TitleStyled>
                <Link href={`/artykuly/${item.seoSlug}`}>{item.title}</Link>
            </TitleStyled>
            <TextStyled>
                <Link href={`/artykuly/${item.seoSlug}`}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: item.teaser
                        }}
                    />
                </Link>
            </TextStyled>
        </Col>
    </Row>
);
interface Props {
    interestingArticles: Article[];
}

const InterestingArticles = ({ interestingArticles }: Props): JSX.Element => {
    if (interestingArticles.length > 1) {
        return (
            <Row>
                {interestingArticles.map((item) => (
                    <Col key={item.seoSlug}>
                        <ArticleItem item={item} />
                    </Col>
                ))}
            </Row>
        );
    }
    return <ArticleItem item={interestingArticles[0]} />;
};

export default InterestingArticles;
